const Fotos = () => {
  return <div className="App"></div>;
};

export default Fotos;
